module.exports = __webpack_public_path__ + "img/vertical_6_3_8004.eab77803.png";